export const GET_ORGANIZATION_GROUPS_START =
  'GET_ORGANIZATION_GROUPS_START';
export const GET_ORGANIZATION_GROUPS_SUCCESS =
  'GET_ORGANIZATION_GROUPS_SUCCESS';
export const GET_ORGANIZATION_GROUPS_ERROR =
  'GET_ORGANIZATION_GROUPS_ERROR';
